import { times } from "lodash-es";

import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";
import { Cell } from "src/flow/VersionsTable/VersionsTable";

export const VersionsTableRowSkeleton: React.FC<{
  numberOfColumns: number;
}> = ({ numberOfColumns }) => (
  <tr>
    {times(numberOfColumns, (i: number) => (
      <Cell key={i}>
        <SkeletonPlaceholder height="h-5" />
      </Cell>
    ))}
  </tr>
);
